import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const agencyResourceService = {
    storeAgencyResource,
    getAgencyResource,
    editAgencyResource,
    deleteAgencyResource,
    getCurrentAgencyResource,
    updatePermission,
    getAgencyResourcesPagination,
    getAgencyResourcesTypes,
    getResourcesByRole,
    getOrdersResourcesByRole,
    getAgencyResourceByType,
    getAgencyDocumentsPagination,
    storeAgencyDocument,
    deleteAgencyDocument
}


function storeAgencyResource(agencyId, agencyResourceData) {
    return SC.postCall(`updateAgencyResource/${pathSegment(agencyId)}`, agencyResourceData);
}

function storeAgencyDocument(agencyId, agencyDocumentData) {
    return SC.postCall(`uploadAgencyDocument/${pathSegment(agencyId)}`, agencyDocumentData);
}

function getAgencyResource(agency_id, agencyResourceId) {
    return SC.getCall(`agencyResources/${pathSegment(agency_id)}/${pathSegment(agencyResourceId)}/show`);
}

function editAgencyResource(agencyId, agencyResourceData) {
    return SC.postCall(`updateAgencyResource/${pathSegment(agencyId)}`, agencyResourceData);
}

function deleteAgencyResource(agency_id, agencyResourceId) {
    return SC.deleteCall(`deleteAgencyResource/${pathSegment(agency_id)}/${pathSegment(agencyResourceId)}`);
}

function deleteAgencyDocument(agency_id, id) {
    return SC.deleteCall(`deleteAgencyDocument/${pathSegment(agency_id)}/${pathSegment(id)}`);
}

function getAgencyResourcesPagination(agency_id) {
    return SC.getCall(`getAgencyResources/${pathSegment(agency_id)}`);
}

function getAgencyDocumentsPagination(agency_id) {
    return SC.getCall(`getAgencyDocuments/${pathSegment(agency_id)}`);
}

function getAgencyResourcesTypes(agency_id) {
    return SC.getCall(`getAgencyResourceTypes/${pathSegment(agency_id)}`);
}

function getCurrentAgencyResource() {
    return SC.getCall('getUsersData');
}

function updatePermission(agencyResourceId) {
    return SC.getCall(`changePrimaryContact/${pathSegment(agencyResourceId)}`);
}

function getResourcesByRole(agency_id, order_id) {
    if (order_id) {
        return SC.getCall(`getResourcesByRole/${pathSegment(agency_id)}/${pathSegment(order_id)}`);
    }
    return SC.getCall(`getResourcesByRole/${pathSegment(agency_id)}`);
}

function getOrdersResourcesByRole(order_id) {
    return SC.getCall(`getResourcesByRoleForOrder/${pathSegment(order_id)}`);
}

function getAgencyResourceByType(type, agency_id) {
    return SC.getCall(`getAgencyResourceByType/${pathSegment(agency_id)}/${pathSegment(type)}`);
}
